<div id="form">
    <button class="edit" color="primary" mat-fab *ngIf="!isEditable" cdkDrag (click)="wasEdit()"
        cdkDragBoundary=".contentFlex" (mousedown)="ifDown()" (mousemove)="onMouseMove($event)"
        matTooltip="Click here to edit charge details">
        <i MatSuffix id="i1" class="flaticon-pencil-tool"></i>
    </button>
    <mat-stepper orientation="vertical" [linear]="isLinear" #stepper>
        <mat-step [completed]="isStepOneComplete">
            <div fxFlex="100" class="inputs col2" fxLayout="row wrap">
                <ng-template matStepLabel>Create/Edit Charge</ng-template>
                <app-edit-suggestion-field [isEditable]="isEditable" [label]="'Charge Name*'"
                    [displayField]="'charge_head'" [name]="'charge_head'" [(ngModel)]="chargeObject.charge_head"
                    (onSelect)="editChargeMaster($event)" [listUrl]="charge_url" [minlength]="3" fxFlex="14.3em"
                    fxLayout="column" [(errors)]="chargeObject.errors.charge_head" class="align-items-center">
                </app-edit-suggestion-field>

                <app-text-field [isMultiline]="false" [isEditable]="isEditable" [label]="'Display Name on Invoice*'"
                    [(ngModel)]="chargeObject.print_name" [name]="'print_name'" [minlength]="3" fxFlex="14.3em"
                    fxLayout="column" [(errors)]="chargeObject.errors.print_name" class="align-items-center">
                </app-text-field>

                <app-text-field [isMultiline]="false" [isEditable]="isEditable" [label]="'Charge Code'"
                    [(ngModel)]="chargeObject.charge_code" [name]="'charge_code'" [minlength]="3" fxFlex="14.3em"
                    fxLayout="column" [(errors)]="chargeObject.errors.charge_code" class="align-items-center">
                </app-text-field>

                <app-text-field [isMultiline]="true" [isEditable]="isEditable" [label]="'Description'"
                    [(ngModel)]="chargeObject.description" [name]="'description'" fxFlex="14.3em" fxLayout="column"
                    [(errors)]="chargeObject.errors.description" class="align-items-center">
                </app-text-field>

                <app-mat-auto-search [isEditable]="isEditable" [label]="'Charge Category*'"
                    [ngModel]="chargeObject.charge_category" (ngModelChange)="setChargeCategory($event)"
                    [name]="'charge_category'" [idField]="null" [setSearchValue]="true" [searchIcon]="true"
                    fxFlex="14.3em" [listUrl]="charge_category_url" fxLayout="column"
                    [labelItemTemplate]="chargeSelectedItem" [itemTemplate]="chargeItem"
                    [displayTemplate]="chargeDisplayItem" [(errors)]="chargeObject.errors.charge_category"
                    class="align-items-center">
                </app-mat-auto-search>

                <app-toggle-select [isEditable]="isEditable" [label]="'Charge is*'"
                    [(ngModel)]="chargeObject.receivable_payable" [name]="'receivable_payable'" [displayField]="'value'"
                    [options]="charge_nature?.results" fxFlex="14.3em" fxLayout="column"
                    [(errors)]="chargeObject.errors.receivable_payable" class="align-items-center">
                </app-toggle-select>

                <app-toggle-select class="inputToggle" [isEditable]="isEditable" [label]="'Unit of Measurement (per)*'"
                    [(ngModel)]="chargeObject.uom" [name]="'uom'" [displayField]="'value'"
                    [options]="UOM_Charge?.results" fxFlex="14.3em" fxLayout="column"
                    [(errors)]="chargeObject.errors.uom" class="align-items-center">
                </app-toggle-select>

                <app-mat-auto-search [isEditable]="isEditable" [label]="'HSN/SAC Code*'"
                    [(ngModel)]="chargeObject.hsn_code" [name]="'hsn_code'" [idField]="null" [listUrl]="hsn_url"
                    [searchIcon]="true" [labelItemTemplate]="hsnSelectedItem" [itemTemplate]="hsnItem"
                    [displayTemplate]="hsnDisplayItem" fxFlex="14.3em" fxLayout="column"
                    [(errors)]="chargeObject.errors.hsn_code" class="align-items-center">
                </app-mat-auto-search>

                <app-mat-auto-search [isEditable]="isEditable" [multiple]="false" [label]="'Charge Group'"
                    [name]="'charge_group'" [(ngModel)]="chargeObject.charge_group"
                    (ngModelChange)="setChargeGroup($event)" [setSearchValue]="true" [searchIcon]="true"
                    [listUrl]="charge_group_url" [displayField]="'name'" [idField]="null" fxFlex="14.3em"
                    fxLayout="column" class="align-items-center">
                </app-mat-auto-search>

                <div fxLayout="column" [class.gap-2]="isEditable">
                    <div class="inputTitle">
                        <span> {{isEditable ? 'Select':'Selected '}} Charge Nature {{isEditable ?
                            'as applicable' : ''}}</span>
                    </div>
                    <section fxLayout="row" class="col2">
                        <mat-checkbox fxFlex="14.3em" color="primary" [(ngModel)]="chargeObject.is_incidental " checked
                            [disabled]="!isEditable">
                            Incidental Charge
                        </mat-checkbox>
                        <mat-checkbox fxFlex="14.3em" color="primary" [(ngModel)]="chargeObject.is_time_based " checked
                            [disabled]="!isEditable">
                            Time Based Charge
                        </mat-checkbox>
                        <mat-checkbox fxFlex="14.3em" color="primary" [(ngModel)]="chargeObject.is_rcm_applicable "
                            checked [disabled]="!isEditable">
                            RCM applicable
                        </mat-checkbox>
                        <mat-checkbox fxFlex="14.3em" color="primary" [(ngModel)]="chargeObject.is_amount_editable " checked
                            [disabled]="!isEditable">
                            Is Amount Editable
                        </mat-checkbox>
                    </section>
                </div>
                <div class="w-100 col2 p-t-15" fxLayout="row wrap">
                    <div fxFlex="14.3em" fxLayout="column" class="justify-content-center">
                        <section>
                            <mat-checkbox color="primary" [(ngModel)]="chargeObject.is_active" checked
                                [disabled]="!isEditable" (click)="inActiveChargeMaster(chargeObject.is_active)">
                                Active
                            </mat-checkbox>
                        </section>
                    </div>

                </div>
                <div fxFlex="100" class="btn1">
                    <ng-container *ngIf="isEditable">
                        <button mat-raised-button (click)="saveCharge()" class="Save"> Save</button>
                    </ng-container>
                </div>
            </div>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>User Charge Mapping</ng-template>
            <div *ngIf="isEditable" class="inputs col2" fxLayout="row wrap" style="padding-bottom: 7.4em;">
                <app-mat-auto-search [isEditable]="isEditable" [label]="'Select Departments*'" [name]="'departments'"
                    [ngModel]="chargeObject.departments" (ngModelChange)="setUserUrl($event)" [setSearchValue]="false"
                    [multiple]="true" [closeOnSelect]="false" [searchIcon]="true" [defaultChip]="false"
                    [listUrl]="department_url" [displayField]="'name'" [idField]="null" [showSelectAll]="true"
                    (showAll)="showAllDepartments($event)" fxFlex="14.3em" fxLayout="column" class="align-items-center"
                    [(errors)]="chargeObject.errors.departments">
                </app-mat-auto-search>

                <app-mat-auto-search [isEditable]="isEditable" [label]="'Excluded Users'" [name]="'exclude_users'"
                    [(ngModel)]="chargeObject.exclude_users" [setSearchValue]="false" [multiple]="true"
                    [closeOnSelect]="false" [searchIcon]="true" [defaultChip]="false" [listUrl]="userListUrl"
                    [displayField]="'full_name'" [idField]="null" [showSelectAll]="true"
                    (showAll)="showAllUsers($event)" fxFlex="14.3em" fxLayout="column" class="align-items-center"
                    [disabled]="disableUserField" [(errors)]="chargeObject.errors.exclude_users">
                </app-mat-auto-search>
            </div>
            <div *ngIf="!isEditable">
                <div>
                    <div *ngIf="chargeObject.departments.length">Charge Head visible to departments:
                        <div>
                            <mat-chip *ngFor="let dept of chargeObject.departments"
                                style="color:#ffffff; background: #f05f25; ">{{dept?.name}}</mat-chip>
                        </div>
                    </div>
                    <div *ngIf="chargeObject.exclude_users.length">Users excluded to view the charge head :
                        <div>
                            <mat-chip *ngFor="let user of chargeObject.exclude_users">{{user?.full_name}}
                                ({{user?.department?.name}})</mat-chip>
                        </div>
                    </div>
                </div>
                <div *ngIf="!chargeObject.departments.length" class="noDataText">
                    <span>No User Charge Mappings exists.</span>
                </div>
            </div>
            <div class="btn1 w-100" *ngIf="isEditable">
                <button mat-raised-button (click)="saveUserChargeMapping()" class="Save"> Save</button>
            </div>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>External Source Charge-ID Mapping</ng-template>
            <div class="mappingInputs" fxLayout="row wrap" *ngIf="isEditable">
                <div fxFlex="95" class="leaseRequest">
                    <div class="leasebox">
                        <div class="requestType" *ngFor="let map of chargeObject.external_mappings, let i=index">

                            <app-mat-auto-search [isEditable]="isEditable" fxFlex="12.3em" fxLayout="column"
                                class="containerType " [searchIcon]="true" [ngModel]="map.app_name"
                                [label]="'Application Name*'" (ngModelChange)="setESCIDescription($event,i)"
                                [name]="'app_name'+i" [idField]="null" [displayField]="'name'" [clearable]="true"
                                [listUrl]="ext_app_listUrl" [(errors)]="map.mapErr.app_name">
                            </app-mat-auto-search>

                            <app-text-field [isEditable]="isEditable" [(ngModel)]="map.charge_code"
                                [name]="'charge_code'+i" [minlength]="3" [label]="'Charge Code*'" fxFlex="12.3em"
                                fxLayout="column" [(errors)]="map.mapErr.charge_code">
                            </app-text-field>

                            <app-text-field [isEditable]="isEditable" [(ngModel)]="map.description" fxFlex="12.3em"
                                fxLayout="column" [name]="'description'+i" [minlength]="5" [label]="'Description*'"
                                [(errors)]="map.mapErr.description">
                            </app-text-field>

                            <div class="actionBtn" *ngIf="isEditable">
                                <i class="flaticon-delete" (click)="removeESCIMapping(i)" matTooltip="Delete"
                                    matTooltipPosition="right" matTooltipHideDelay="2000"
                                    *ngIf="chargeObject.external_mappings?.length > 1"></i>
                            </div>
                        </div>
                    </div>
                    <span class="addReq" *ngIf="isEditable" (click)="addESCIMapping()" matTooltip="Add ESCI Mapping"
                        matTooltipPosition="left" matTooltipHideDelay="2000">+
                        Add</span>
                </div>
            </div>

            <div *ngIf=" !isEditable" class="setTable">
                <mat-table *ngIf="chargeObject.external_mappings[0].app_name != null"
                    [dataSource]="chargeObject.external_mappings">
                    <ng-container [matColumnDef]="'app_name'">
                        <mat-header-cell *matHeaderCellDef>Application Name</mat-header-cell>
                        <mat-cell *matCellDef="let data" class="fs-12">
                            {{data.app_name?.name ?? '-'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container [matColumnDef]="'charge_code'">
                        <mat-header-cell *matHeaderCellDef>Charge Code</mat-header-cell>
                        <mat-cell *matCellDef="let data" class="fs-12">
                            {{data.charge_code ?? '-'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container [matColumnDef]="'description'">
                        <mat-header-cell *matHeaderCellDef>Description</mat-header-cell>
                        <mat-cell *matCellDef="let data" class="fs-12">
                            {{data.description ?? '-'}}
                        </mat-cell>
                    </ng-container>

                    <mat-header-row class="header-row"
                        *matHeaderRowDef="externalMappingDisplayColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: externalMappingDisplayColumns;"></mat-row>
                </mat-table>
                <div *ngIf="chargeObject.external_mappings[0].app_name == null" class="noDataText">
                    <span>No External Source Charge-ID Mapping exists.</span>
                </div>

            </div>
            <div class="btn1">
                <ng-container *ngIf="isEditable">
                    <button mat-raised-button (click)="saveExternalChargeMapping()" class="Save">Save</button>
                </ng-container>
            </div>
        </mat-step>
    </mat-stepper>
</div>


<!-- Charge Category -->
<ng-template #chargeItem let-item let-index>
    {{item?.charge_category_name}}
</ng-template>

<ng-template #chargeSelectedItem let-item>
    {{item?.charge_category_name}}
</ng-template>

<ng-template #chargeDisplayItem let-item>
    {{item?.charge_category_name}}
</ng-template>

<!-- HSN -->
<ng-template #hsnSelectedItem ng-label-tmp let-item>
    {{item?.code}}
</ng-template>

<ng-template #hsnItem let-item>
    <div fxLayout="column" class="m-t-8 m-b-8">
        <span class="country-code">{{item?.code}}</span>
        <span class="hsn-code">{{item?.description}}</span>
    </div>
</ng-template>

<ng-template #hsnDisplayItem ng-label-tmp let-item>
    {{item?.code}}
</ng-template>